module.exports = __webpack_public_path__ + "static/media/web.9331f972.svg";